/**
 * AR content for the "Saint-Paul-de-Vence" private excursion.
 *
 * Role: Arabic (MSA) translation of slugs/saint-paul-de-vence.ts, typed
 * `ExcursionPage` for the shared ExcursionSlugView.
 * Dependencies: slug-excursions (type), image. Slug mirrors FR (place name).
 */
import type { ExcursionPage } from "../slug-excursions";
import stpaulvence from "@/assets/images/excursions/destinations/st-paul-vence.jpeg";

const page: ExcursionPage = {
  slug: "saint-paul-de-vence",
  hero: {
    title: "رحلة سان بول دو فانس",
    subtitle:
      "فن وصالات عرض وأسوار: جوهرة من القرون الوسطى قرب الريفييرا الفرنسية.",
    ctaPrimaryHref: "/reservation",
    ctaPrimaryLabel: "احجز الآن",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "اطلب عرض سعر",
    image: stpaulvence,
  },
  highlights: {
    title: "أبرز المعالم",
    items: [
      { text: "أسوار وأزقّة سان بول دو فانس" },
      { text: "صالات عرض فنية ومراسم وفنّانون مقيمون" },
      { text: "مؤسسة ماغت القريبة (اختياري)" },
      { text: "إطلالات على المناطق الداخلية والبحر (في الأيام الصافية)" },
    ],
  },
  itinerary: {
    title: "برنامج مقترح",
    steps: [
      {
        title: "الانطلاق من كان",
        description: "طريق خلّاب نحو المناطق الداخلية.",
      },
      {
        title: "اكتشاف القرية",
        description: "الأسوار والساحات وصالات العرض.",
      },
    ],
  },
  practical: {
    title: "معلومات عملية",
    items: [
      { label: "المدة", value: "من 3 إلى 5 ساعات" },
      { label: "الانطلاق", value: "كان" },
      { label: "الأحذية", value: "أرضية مرصوفة بالحجارة، احرص على الراحة" },
      { label: "خيار", value: "زيارة مؤسسة ماغت (حسب أوقات الفتح)" },
    ],
  },
};

export default page;
